/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import Message from "../../common/components/Message";

import config from '../../config'
import * as Api from "../../common/Api";

const initialState = {
    replying: false,
    reload: false,
    isTyping: false,
    currentConversationId: '',
    currentConversationName: '',
    alertMessage: undefined,
    successMessage: undefined,
    messages: [],
    conversations: [],
    loading: false,
};

export const getChatMessages = createAsyncThunk('chatMessage/get-chat-messages', async (payload, { getState, rejectWithValue }) => {
    try {
        const conversationId = payload;
        let messages = [];
        if(conversationId !== undefined) {
            const GET_URL = `${config.services.ATLAS.apiUrl}/chat-api/conversation/${conversationId}`;
            messages = await Api.get(true, GET_URL);
        }
        return messages;
    }
    catch (err){
        console.log(`Error in getChatMessages and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});

export const selectConversation = createAsyncThunk('chatMessage/selectConversation', async (payload, { getState, rejectWithValue }) => {
    const state = getState()['chatMessages'];
    const conversation = state.conversations.find(conversation => conversation.id === payload);
    return conversation;
});


export const getConversations = createAsyncThunk('chatMessage/get-conversations', async (payload, { getState, rejectWithValue }) => {
    try {
        const GET_URL = `${config.services.ATLAS.apiUrl}/conversation`;
        const messageResponse = await Api.get(true, GET_URL);
        return messageResponse;
    }
    catch (err){
        console.log(`Error in getChatMessages and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});

export const submitChatMessage = createAsyncThunk('chatMessage/submit-chat-message', async (message, {getState, rejectWithValue}) => {

    try {
            const POST_URL = `${config.services.ATLAS.apiUrl}/chat-api`;
            const state = getState()['chatMessages'];

            const messageResponse = await Api.post(true, POST_URL, {options: {},
                data: {conversationId: state.currentConversationId,
                    message:message}},);
            return messageResponse;
       // }
    }
    catch (err){
        console.log(`Error in submitChatMessage and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});


const chatMessagesSlice = createSlice({
    name: 'chatMessagesSlice', initialState,
    reducers: {
        clearSelected: {
            reducer(state, action) {
                state.selectedId = [];
                state.selectedMatchTypes = [];
            }
        },
        clearCurrentConversationId: {
            reducer(state, action) {
                state.currentConversationId = '';
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConversations.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getConversations.fulfilled, (state, action) => {
                state.conversations = action.payload;
                state.loading = false;
            })
            .addCase(getConversations.rejected, (state, action) => {
                state.alertMessage = action.payload;
                state.loading = false;
            })
            .addCase(selectConversation.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(selectConversation.fulfilled, (state, action) => {
                state.currentConversationId = action.payload.id;
                state.currentConversationName = action.payload.name;
                state.loading = false;
            })
            .addCase(selectConversation.rejected, (state, action) => {
                state.alertMessage = action.payload;
                state.loading = false;
            })
            .addCase(getChatMessages.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getChatMessages.fulfilled, (state, action) => {
               if(action.payload) {
                  state.messages = action.payload.messages;
               }
                state.loading = false;
            })
            .addCase(getChatMessages.rejected, (state, action) => {
                state.alertMessage = action.payload;
                state.loading = false;
            })
            .addCase(submitChatMessage.pending, (state, action) => {
                state.isTyping = true;
                state.messages = [...state.messages, new Message({id:0, message: action.meta.arg})];
                state.loading = true;
            })
            .addCase(submitChatMessage.fulfilled, (state, action) => {
                state.isTyping = false;
                state.messages = [...state.messages, ...action.payload.messages];
                state.currentConversationId = action.payload.conversationId;
                if(action.payload.conversationId !== ''){
                    state.currentConversationName = action.payload.conversationName;
                }
                state.loading = false;
            })
            .addCase(submitChatMessage.rejected, (state, action) => {
                state.alertMessage = action.payload;
                state.loading = false;
            });
    }
});


export const {
    clearSelected, clearCurrentConversationId
} = chatMessagesSlice.actions;

export default chatMessagesSlice.reducer;
